/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { AccountComplianceDto } from '../model/accountComplianceDto';
// @ts-ignore
import { AssetDto } from '../model/assetDto';
// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { OrderComplianceDto } from '../model/orderComplianceDto';
// @ts-ignore
import { PairDto } from '../model/pairDto';
// @ts-ignore
import { PeriodVolumeStatisticComplianceDto } from '../model/periodVolumeStatisticComplianceDto';
// @ts-ignore
import { TransferComplianceDto } from '../model/transferComplianceDto';
// @ts-ignore
import { UserDto } from '../model/userDto';
// @ts-ignore
import { UserSettingDto } from '../model/userSettingDto';
// @ts-ignore
import { VolumeStatisticComplianceDto } from '../model/volumeStatisticComplianceDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface ClientReport1RequestParams {
  /** Account ID for filtering */
  accountId?: number;
  /** Include pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Jurisdiction for filtering */
  jurisdiction?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

export interface DownloadReport1RequestParams {
  id: number;
}

export interface GetAccounts1RequestParams {
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
}

export interface GetOrders1RequestParams {
  /** Include Account IDs for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Exclude Account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Include Pair IDs for filtering. Can be filled if \&#39;excludePairIds\&#39; is empty. */
  pairId?: Array<number>;
  /** Exclude Pair IDs for filtering. Can be filled if \&#39;pairId\&#39; is empty. */
  excludePairIds?: Array<number>;
  /** Order statuses for filtering */
  orderStatus?: Array<
    'ACTIVE' | 'CANCELED' | 'FILLED' | 'PARTIALLY_FILLED' | 'PARTIALLY_FILLED_CANCELED' | 'REJECTED' | 'WAITING_TRIGGER'
  >;
  /** If true - exclude account House. */
  excludeHouseLp?: boolean;
  /** If true - filled quantity exists. */
  existFilledQty?: boolean;
  /** Jurisdiction for filtering. */
  jurisdiction?: string;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Skip count, should be &gt;&#x3D; 0. Default 0 */
  skipCount?: number;
  /** If true - returns only active orders */
  activeOnly?: boolean;
  /** Sort direction by receiveTime column. ASC or DESC(default) */
  sortDirection?: 'ASC' | 'DESC';
  /** Initiator type */
  initiatorType?: 'ADMIN' | 'API_KEY' | 'USER' | 'ALGO' | 'FIX';
  /** Client order Id for filtering */
  clOrdId?: string;
}

export interface GetSettingByKey1RequestParams {
  key: string;
}

export interface GetTransfers2RequestParams {
  /** Included Client account ID for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Excluded Client account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Included asset IDs for filtering. Can be filled if \&#39;excludedAssetIds\&#39; is empty. */
  assetId?: Array<number>;
  /** Excluded asset IDs for filtering. Can be filled if \&#39;assetId\&#39; is empty. */
  excludedAssetIds?: Array<number>;
  /** Transfer sources */
  source?: Array<'MANUAL' | 'FIREBLOCKS' | 'GOLDEN' | 'EXCHANGE_TO_EXCHANGE' | 'HRP_SETTLEMENT' | 'SUB_ACCOUNT'>;
  /** Transfer statuses */
  status?: Array<'PENDING' | 'ERROR' | 'SETTLED'>;
  /** Jurisdiction for filtering */
  jurisdiction?: string;
  /** Business Entity for filtering */
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
}

export interface GetVolumeStatistic1RequestParams {
  /** From time for filtering, inclusive. Hour precision, round up. */
  fromTime: string;
  /** To time for filtering, inclusive. Hour precision, round down. */
  toTime: string;
}

export interface GetVolumeStatisticForPeriods1RequestParams {
  /** From times for filtering, inclusive, one per period. Hour precision, round up. */
  fromTime: Array<string>;
  /** To times for filtering, inclusive, one per period, in the same order as fromTime. Hour precision, round down. */
  toTime: Array<string>;
}

export interface TransferReport1RequestParams {
  /** Included Client account ID for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Excluded Client account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Included asset IDs for filtering. Can be filled if \&#39;excludedAssetIds\&#39; is empty. */
  assetId?: Array<number>;
  /** Excluded asset IDs for filtering. Can be filled if \&#39;assetId\&#39; is empty. */
  excludedAssetIds?: Array<number>;
  /** Transfer sources */
  source?: Array<'MANUAL' | 'FIREBLOCKS' | 'GOLDEN' | 'EXCHANGE_TO_EXCHANGE' | 'HRP_SETTLEMENT' | 'SUB_ACCOUNT'>;
  /** Transfer statuses */
  status?: Array<'PENDING' | 'ERROR' | 'SETTLED'>;
  /** Jurisdiction for filtering */
  jurisdiction?: string;
  /** Business Entity for filtering */
  businessEntity?: 'SANDBOX1' | 'SANDBOX2' | 'INC' | 'BERMUDA' | 'BRAZIL';
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Custom time zone */
  customZone?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ComplianceControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Requests client order history csv file
   * @endpoint get /v1/compliance/client-report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public clientReport1(
    requestParameters?: ClientReport1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any>;
  public clientReport1(
    requestParameters?: ClientReport1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<any>>;
  public clientReport1(
    requestParameters?: ClientReport1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<any>>;
  public clientReport1(
    requestParameters?: ClientReport1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const jurisdiction = requestParameters?.jurisdiction;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/client-report`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Download CSV report
   * @endpoint get /v1/compliance/download-report/{id}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public downloadReport1(
    requestParameters: DownloadReport1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<Blob>;
  public downloadReport1(
    requestParameters: DownloadReport1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpResponse<Blob>>;
  public downloadReport1(
    requestParameters: DownloadReport1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpEvent<Blob>>;
  public downloadReport1(
    requestParameters: DownloadReport1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling downloadReport1.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let localVarPath = `/v1/compliance/download-report/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: 'blob',
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets all accounts
   * @endpoint get /v1/compliance/accounts
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getAccounts1(
    requestParameters?: GetAccounts1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<AccountComplianceDto>>;
  public getAccounts1(
    requestParameters?: GetAccounts1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<AccountComplianceDto>>>;
  public getAccounts1(
    requestParameters?: GetAccounts1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<AccountComplianceDto>>>;
  public getAccounts1(
    requestParameters?: GetAccounts1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const businessEntity = requestParameters?.businessEntity;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/accounts`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AccountComplianceDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets all assets
   * @endpoint get /v1/compliance/assets
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getAssets2(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<AssetDto>>;
  public getAssets2(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<AssetDto>>>;
  public getAssets2(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<AssetDto>>>;
  public getAssets2(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/assets`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AssetDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets current user
   * @endpoint get /v1/compliance/current-user
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getCurrentUser1(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<UserDto>;
  public getCurrentUser1(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<UserDto>>;
  public getCurrentUser1(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<UserDto>>;
  public getCurrentUser1(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/current-user`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<UserDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets orders(up to 100)
   * @endpoint get /v1/compliance/orders
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getOrders1(
    requestParameters?: GetOrders1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<OrderComplianceDto>>;
  public getOrders1(
    requestParameters?: GetOrders1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<OrderComplianceDto>>>;
  public getOrders1(
    requestParameters?: GetOrders1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<OrderComplianceDto>>>;
  public getOrders1(
    requestParameters?: GetOrders1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const pairId = requestParameters?.pairId;
    const excludePairIds = requestParameters?.excludePairIds;
    const orderStatus = requestParameters?.orderStatus;
    const excludeHouseLp = requestParameters?.excludeHouseLp;
    const existFilledQty = requestParameters?.existFilledQty;
    const jurisdiction = requestParameters?.jurisdiction;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const skipCount = requestParameters?.skipCount;
    const activeOnly = requestParameters?.activeOnly;
    const sortDirection = requestParameters?.sortDirection;
    const initiatorType = requestParameters?.initiatorType;
    const clOrdId = requestParameters?.clOrdId;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'pairId',
      <any>pairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludePairIds',
      <any>excludePairIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'orderStatus',
      <any>orderStatus,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeHouseLp',
      <any>excludeHouseLp,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'existFilledQty',
      <any>existFilledQty,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'activeOnly',
      <any>activeOnly,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'initiatorType',
      <any>initiatorType,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'clOrdId',
      <any>clOrdId,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/orders`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<OrderComplianceDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets all base pairs
   * @endpoint get /v1/compliance/pairs
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getPairs1(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<PairDto>>;
  public getPairs1(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<PairDto>>>;
  public getPairs1(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<PairDto>>>;
  public getPairs1(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/pairs`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PairDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets user setting by key
   * @endpoint get /v1/compliance/user-setting/{key}
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getSettingByKey1(
    requestParameters: GetSettingByKey1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<UserSettingDto>;
  public getSettingByKey1(
    requestParameters: GetSettingByKey1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<UserSettingDto>>;
  public getSettingByKey1(
    requestParameters: GetSettingByKey1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<UserSettingDto>>;
  public getSettingByKey1(
    requestParameters: GetSettingByKey1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const key = requestParameters?.key;
    if (key === null || key === undefined) {
      throw new Error('Required parameter key was null or undefined when calling getSettingByKey1.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/user-setting/${this.configuration.encodeParam({ name: 'key', value: key, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<UserSettingDto>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets last transfers(up to 100)
   * @endpoint get /v1/compliance/transfers
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getTransfers2(
    requestParameters?: GetTransfers2RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<TransferComplianceDto>>;
  public getTransfers2(
    requestParameters?: GetTransfers2RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<TransferComplianceDto>>>;
  public getTransfers2(
    requestParameters?: GetTransfers2RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<TransferComplianceDto>>>;
  public getTransfers2(
    requestParameters?: GetTransfers2RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const assetId = requestParameters?.assetId;
    const excludedAssetIds = requestParameters?.excludedAssetIds;
    const source = requestParameters?.source;
    const status = requestParameters?.status;
    const jurisdiction = requestParameters?.jurisdiction;
    const businessEntity = requestParameters?.businessEntity;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assetId',
      <any>assetId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludedAssetIds',
      <any>excludedAssetIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'source',
      <any>source,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'status',
      <any>status,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/transfers`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<TransferComplianceDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets Volume statistic
   * @endpoint get /v1/compliance/volume-statistics
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getVolumeStatistic1(
    requestParameters: GetVolumeStatistic1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<VolumeStatisticComplianceDto>>;
  public getVolumeStatistic1(
    requestParameters: GetVolumeStatistic1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<VolumeStatisticComplianceDto>>>;
  public getVolumeStatistic1(
    requestParameters: GetVolumeStatistic1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<VolumeStatisticComplianceDto>>>;
  public getVolumeStatistic1(
    requestParameters: GetVolumeStatistic1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling getVolumeStatistic1.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling getVolumeStatistic1.');
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/volume-statistics`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<VolumeStatisticComplianceDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets Volume statistic for several periods
   * @endpoint get /v1/compliance/volume-statistics/periods
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getVolumeStatisticForPeriods1(
    requestParameters: GetVolumeStatisticForPeriods1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<PeriodVolumeStatisticComplianceDto>>;
  public getVolumeStatisticForPeriods1(
    requestParameters: GetVolumeStatisticForPeriods1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<PeriodVolumeStatisticComplianceDto>>>;
  public getVolumeStatisticForPeriods1(
    requestParameters: GetVolumeStatisticForPeriods1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<PeriodVolumeStatisticComplianceDto>>>;
  public getVolumeStatisticForPeriods1(
    requestParameters: GetVolumeStatisticForPeriods1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fromTime = requestParameters?.fromTime;
    if (fromTime === null || fromTime === undefined) {
      throw new Error('Required parameter fromTime was null or undefined when calling getVolumeStatisticForPeriods1.');
    }
    const toTime = requestParameters?.toTime;
    if (toTime === null || toTime === undefined) {
      throw new Error('Required parameter toTime was null or undefined when calling getVolumeStatisticForPeriods1.');
    }

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/volume-statistics/periods`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<PeriodVolumeStatisticComplianceDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Requests transfer history report file
   * @endpoint get /v1/compliance/transfer-report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public transferReport1(
    requestParameters?: TransferReport1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any>;
  public transferReport1(
    requestParameters?: TransferReport1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<any>>;
  public transferReport1(
    requestParameters?: TransferReport1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<any>>;
  public transferReport1(
    requestParameters?: TransferReport1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const assetId = requestParameters?.assetId;
    const excludedAssetIds = requestParameters?.excludedAssetIds;
    const source = requestParameters?.source;
    const status = requestParameters?.status;
    const jurisdiction = requestParameters?.jurisdiction;
    const businessEntity = requestParameters?.businessEntity;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const customZone = requestParameters?.customZone;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'assetId',
      <any>assetId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludedAssetIds',
      <any>excludedAssetIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'source',
      <any>source,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'status',
      <any>status,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'jurisdiction',
      <any>jurisdiction,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'businessEntity',
      <any>businessEntity,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'customZone',
      <any>customZone,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/compliance/transfer-report`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
